import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';

// import ReactPlayer from 'react-player';

// import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
// import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';

import { DemoFormLong } from '../../../components/DemoFormLong.jsx';

class WistiaPlayer extends React.Component {

    componentDidMount  = () => {
		const script = document.createElement("script");
		script.src = "https://fast.wistia.com/embed/medias/j1aatk4i5w.jsonp";
		script.async = true;
		document.body.appendChild(script);

		const script2 = document.createElement("script");
		script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
		script2.async = true;

		document.body.appendChild(script2);	
	}


	render() {
		return (
            <div className="wistia_responsive_padding" style={{padding:"56.25% 0 0 0", margin: "0 0 20px 0", position:"relative", width:"100%"}}>
            <div className="wistia_responsive_wrapper" style={{height: "100%", left: "0", position: "absolute", top: "0", width: "100%"}}>
                <div className="wistia_embed wistia_async_j1aatk4i5w videoFoam=true" style={{height: "100%", position: "relative", width: "100%"}}>
                    <div className="wistia_swatch" style={{height:"100%", left:"0", opacity:"0", overflow:"hidden", position:"absolute", top:"0", transition:"opacity 200ms", width:"100%"}}>
                        <img src="https://fast.wistia.com/embed/medias/j1aatk4i5w/swatch" style={{filter:"blur(5px)", height:"100%", width:"100%"}} alt="Chart Example" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </div>

		);
	}
}

const Home = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;




    return (
        <Layout bodyClass="page-home" ontouchstart>
            <SEO title="ChartHop Scenarios | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="ChartHop Scenarios enables fast, easy, and flexible org design and re-design. Scenarios enable organizations to easily and thoughtfully react, adapt, and plan."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="ChartHop Scenarios | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="ChartHop Scenarios enables fast, easy, and flexible org design and re-design. Scenarios enable organizations to easily and thoughtfully react, adapt, and plan." />
                <meta property="og:image" content={`https://www.charthop.com/landings/Scenario_RemoveOpenRole.gif`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="ChartHop Scenarios | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="ChartHop Scenarios enables fast, easy, and flexible org design and re-design. Scenarios enable organizations to easily and thoughtfully react, adapt, and plan." />
                <meta name="twitter:image" content={`https://www.charthop.com/landings/Scenario_RemoveOpenRole.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>
            {/* PAGE CONTENT */}
            <section className="intro container introductionVideoPage">
                <div className="row align-items-center">

                    {/* <div className="col-12 wistiaFormatTest" >
                        <ReactPlayer
                            url='https://home.wistia.com/medias/e4a27b971d'
                        />
                    </div> */}

         
                    


                        
                    <div className="introducing-charthop-video col-12">
                        <h1>ChartHop Scenarios</h1>
                        <WistiaPlayer/>
                        <p className="pt-1 pb-1">Scenarios enable organizations to easily and thoughtfully react, adapt, and plan. </p> 
                        <p> Whether you need to propose one individual net-new headcount to your engineering team or you need to design a brand new growth-mode plan for your go-to-market team, you can use scenarios to workshop ideas, test out changes before deploying them, and manage key workflows within your organization.</p>

                    </div>
                </div>
            </section>








            {/* CONTACT FORM */}

            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"resources-video-scenarios-demo-bottom"} headertext={HtmlParser("<h2 className='stillH1'>See how ChartHop can help!</br></br> Request a demo now.</h2>")} focusID={HtmlParser("name")} />
            </section>


        </Layout>
    );
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;